export default function useWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
      return {
        width,
        height,
        loadedSizeIsMobile: width < 500
      };
}
